module.exports = __webpack_public_path__ + "6556fbde1bd8ebe044c9d01eeb885bf9.jpg";